<!-- CASO 1: CARGANDO -->
<ng-container *ngIf="loading; else dataTemplate">
  <p-skeleton [width]="width" height="1rem" styleClass="my-1"></p-skeleton>
</ng-container>

<ng-template #dataTemplate>
  <ng-container *ngIf="hasValue; else emptyTemplate">
    {{ text }}
  </ng-container>
</ng-template>

<!-- CASO 3: VACÍO -->
<ng-template #emptyTemplate>
  <span class="text-500">-</span>
</ng-template>
